module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("5ocCE"))).then(() => parcelRequire('jNwiw'));